import PropTypes from 'prop-types';

/**
 * Componente de botones de acción unificado
 * Proporciona botones de acción consistentes para todas las tablas
 */
const ActionButtons = ({ actions, row, size = 'medium' }) => {
  // Función para determinar el tipo de acción
  const getActionType = (action) => {
    if (typeof action.type === 'function') {
      return action.type(row);
    }
    return action.type || 'default';
  };

  // Función para determinar el icono de acción
  const getActionIcon = (action) => {
    if (typeof action.icon === 'function') {
      return action.icon(row);
    }
    return action.icon;
  };

  // Función para determinar el label de acción
  const getActionLabel = (action) => {
    if (typeof action.label === 'function') {
      return action.label(row);
    }
    return action.label;
  };

  // Función para determinar si la acción está deshabilitada
  const isActionDisabled = (action) => {
    if (typeof action.disabled === 'function') {
      return action.disabled(row);
    }
    return action.disabled || false;
  };

  // Función para determinar si la acción está oculta
  const isActionHidden = (action) => {
    if (typeof action.hidden === 'function') {
      return action.hidden(row);
    }
    return action.hidden || false;
  };

  // Filtrar acciones visibles
  const visibleActions = actions.filter(action => !isActionHidden(action));

  // Si no hay acciones visibles, no renderizar nada
  if (visibleActions.length === 0) {
    return null;
  }

  return (
    <div className={`action-buttons action-buttons-${size}`}>
      {visibleActions.map((action, index) => {
        const actionType = getActionType(action);
        const actionIcon = getActionIcon(action);
        const actionLabel = getActionLabel(action);
        const disabled = isActionDisabled(action);

        return (
          <button
            key={action.key || index}
            className={`action-button action-button-${actionType} ${disabled ? 'disabled' : ''}`}
            onClick={(e) => {
              e.stopPropagation();
              if (!disabled && action.onClick) {
                action.onClick(row);
              }
            }}
            disabled={disabled}
            title={actionLabel}
            aria-label={actionLabel}
          >
            <span className="material-icons">{actionIcon}</span>
            {size === 'large' && (
              <span className="action-label">{actionLabel}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

ActionButtons.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    hidden: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
  })).isRequired,
  row: PropTypes.object.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default ActionButtons;
